<template>
    <canvas id="curve-chart" :width="curveWidth" :height="curveHeight"></canvas>
</template>

<script>
import Chart from "chart.js/auto";

export default {
    name : "DNACurve",
    props: {
        curveWidth: {
            type: Number,
            default: 800
        },
        curveData : {
            type : Array,
            default : function() {
                return [];
            }
        }
    },

    data() {
        return {
            path: null
        };
    },

    mounted() {
        this.calcCurve();
    },

    watch: {
        curveData() {
            this.calcCurve();
        }
    },

    computed: {
        curveHeight() {
            return this.curveWidth * .04;
        }
    },

    methods: {
        calcCurve() {
            this.$nextTick(() => {
                var ctx = document.getElementById("curve-chart");
                if (ctx === null) return;

                const chart = {
                    type: "line",
                    data: {
                        labels:  ["LP1",
                            "LP2",
                            "LP3",
                            "LP4",
                            "LP5",
                            "LP6",
                            "LP7",
                            "LP8",
                            "LP9",
                            "LP10",
                            "LP11",
                            "LP12",
                            "LP13"],
                        datasets: [{
                            label: "",
                            data: this.curveData,
                            fill: false,
                            borderColor: "rgb(0, 0, 0)",
                            borderDash: [
                                5,
                                5
                            ],
                            pointRadius: 0,
                            tension: .35
                        }]
                    },
                    options: {
                        plugins: {
                            title: {
                                display: false
                            },
                            legend: {
                                display: false
                            },
                            responsive: false,
                            maintainAspectRatio: false
                        },
                        animation : false,
                        scales: {
                            y: {
                                display : false,
                                min : Math.min(... this.curveData) - 7.5,
                                max : Math.max(... this.curveData) + 5
                            },
                            x: {
                                display : false
                            }
                        }
                    }
                };

                if (this.chart) {
                    this.chart.destroy();
                }
                this.chart = new Chart(ctx, chart);
            });
        }

    }
};
</script>

<style lang="scss" scoped>
    #curve-chart {
        margin-top : .7rem;
    }
</style>
